import { GET } from "./_config";

export const getCompanyDetailsApi = async () => await GET(`/company`, true);

const companyService = {
  getCompanyDetailsApi,
};

export default companyService;
